<div class="footer" *ngIf="step == 0">
  <button class="btn next-step-btn submit" (click)="onContinueClick()">
    <span> {{ buttonText | translate }} </span>
  </button>
</div> 